// extracted by mini-css-extract-plugin
export var closeButton = "_pf-2";
export var closeButtonIcon = "_pf-3";
export var lightboxContent = "_pf-1";
export var lightboxOverlay = "_pf-0";